import { Model, ModelsByBrandId } from "services/filter/getModelsByBrandIds";
import { FilterMerk } from "services/filter/types";
import throttle from "lodash/throttle";

const ONE_HOUR = 1000 * 60 * 60;

const logDuplicates = (seen: Record<string, boolean>) => () => {
    console.error(
        `duplicate model keys found at ${
            (document && document.URL) || process.env.ENV_NAME || "env not found"
        }:`,
        seen
    );
};

/** Filters duplicates with the same modelId out and logs any duplicates and the place where the
 * duplicate was. */
export function uniqueModels(a: Model[] = []): Model[] {
    const seen: Record<string, boolean> = {};

    const noDuplicateModels = a.filter((x) => {
        // If we've already seen it then filter it
        if (seen[x.modelId]) {
            return false;
        }

        // Otherwise add it to the "seen" models
        seen[x.modelId] = true;

        return true;
    });

    // Log that we have a duplicate model id but only once per hour because otherwise this is
    // annoying to dev with at the moment
    if (Object.values(seen).length) {
        throttle(logDuplicates(seen), ONE_HOUR);
    }

    return noDuplicateModels;
}

export const getModelOptions = (
    brandIds: string[] = [],
    brands: FilterMerk[],
    counts: any,
    models: ModelsByBrandId
) => {
    return brandIds?.map((brandId) => {
        const noModelDupes = uniqueModels(models[brandId]);

        return {
            label: brands.filter((brand) => brand.merkId === brandId)[0]?.naam,
            options: noModelDupes
                .filter((x) => {
                    const id = x?.modelId;
                    return counts?.[id] > 0;
                })
                .map((model) => {
                    const id = model.modelId;
                    const aantal = counts?.[id] || 0;

                    return {
                        ...model,
                        id,
                        aantal,
                        displayName: model.naam,
                        tagName: model.naam,
                        merkId: brandId,
                        selected: false
                    };
                })
        };
    });
};
